// Copyright (c) 2020 WiseTime. All rights reserved.

import { TimelineServiceClient } from "../../generated/wisetime/user/timeline/v4/TimelineServiceClientPb"
import { getBaseUrl } from "../routing"
import { UserServiceClient } from "../../generated/wisetime/account/user/v4/UserServiceClientPb"
import { MembershipServiceClient } from "../../generated/legebill/site/membership/v4/MembershipServiceClientPb"
import { TagServiceClient } from "../../generated/legebill/site/tag/v4/TagServiceClientPb"
import { ActivityTypeServiceClient } from "../../generated/legebill/site/activitytype/v4/Activity_typeServiceClientPb"
import { ServerStreamingRpcInterceptor, UnaryRpcInterceptor } from "./interceptor"
import { isDevelopmentEnv } from "../config"
import { SiteServiceClient } from "../../generated/legebill/site/v4/SiteServiceClientPb"
import { PreferencesServiceClient } from "../../generated/wisetime/user/preferences/v4/PreferencesServiceClientPb"
import { UserCuesServiceClient } from "../../generated/wisetime/user/cues/v4/User_cuesServiceClientPb"
import { NotificationServiceClient } from "../../generated/wisetime/user/notification/v4/NotificationServiceClientPb"
import { PostExpectationServiceClient } from "../../generated/legebill/site/postexpectation/v4/Post_expectationServiceClientPb"
import { debug } from "../logging"
import { AssistantServiceClient } from "../../generated/wisetime/user/assistant/v4/AssistantServiceClientPb"
import {
  UserTimelineMessageServiceClient
} from "../../generated/wisetime/user/timelinemessage/v4/User_timeline_messageServiceClientPb"
import { UserTeamServiceClient } from "../../generated/wt/svc/customer/User_teamServiceClientPb"
import { NarratePreferencesServiceClient } from "../../generated/wisetime/user/assistant/v4/PreferencesServiceClientPb"

const unaryInterceptorOpts = (): { [k: string]: any } => {
  const opts = { unaryInterceptors: [new UnaryRpcInterceptor()], }
  return isDevelopmentEnv() ? { ...opts, withCredentials: true } : opts
}

const rpcInterceptorOpts = (): { [k: string]: any } => {
  const opts = {
    unaryInterceptors: [new UnaryRpcInterceptor()],
    streamInterceptors: [new ServerStreamingRpcInterceptor()],
  }
  return isDevelopmentEnv() ? { ...opts, withCredentials: true } : opts
}

// gRPC clients
export const timelineClient: TimelineServiceClient =
  new TimelineServiceClient(
    getBaseUrl(),
    null,
    rpcInterceptorOpts()
  )

export const userClient: UserServiceClient =
  new UserServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const preferencesClient: PreferencesServiceClient =
  new PreferencesServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const membershipClient: MembershipServiceClient =
  new MembershipServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const siteClient: SiteServiceClient =
  new SiteServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const tagServiceClient: TagServiceClient =
  new TagServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const activityTypeServiceClient: ActivityTypeServiceClient =
  new ActivityTypeServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const userCuesServiceClient: UserCuesServiceClient =
  new UserCuesServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const notificationServiceClient: NotificationServiceClient =
  new NotificationServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const postExpectationsClient: PostExpectationServiceClient =
  new PostExpectationServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const assistantClient: AssistantServiceClient =
  new AssistantServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const userTimelineMessageClient: UserTimelineMessageServiceClient =
  new UserTimelineMessageServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const userTeamClient: UserTeamServiceClient =
  new UserTeamServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

export const narratePreferencesClient: NarratePreferencesServiceClient =
  new NarratePreferencesServiceClient(
    getBaseUrl(),
    null,
    unaryInterceptorOpts()
  )

// Configure grpc-web-devtools for local development
// see https://github.com/SafetyCulture/grpc-web-devtools
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore:next-line
const enableDevTools = window.__GRPCWEB_DEVTOOLS__ || (() => { debug("grpc-web-devtools not configured") })
if (isDevelopmentEnv()) {
  enableDevTools([
    timelineClient,
    userClient,
    preferencesClient,
    membershipClient,
    siteClient,
    tagServiceClient,
    activityTypeServiceClient,
    userCuesServiceClient,
    notificationServiceClient,
    postExpectationsClient,
  ])
}
